import endpoints from "./endpoints";
import api from "./api";

export default {
  getErpProfiles() {
    return api.get(endpoints.erp.profiles).then((x) => Promise.resolve(x.data));
  },
  getErpParameters() {
    return api.get(endpoints.erp.parameters).then((x) => Promise.resolve(x.data));
  }
};
